import { ButtonProps, Icon } from '@mis/sushi-tailwind-react';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { GreenButton } from '../green-button/GreenButton';

import { SecondaryButton } from '../secondary-button/SecondaryButton';
import { TransparentButton } from '../transparent-button/TransparentButton';

export interface AddButtonProps extends ButtonProps {
  mode?: 'green' | 'transparent' | 'secondary';
}

const getButtonElement = (mode?: string) => {
  switch (mode) {
    case 'green':
      return GreenButton;
    case 'transparent':
      return TransparentButton;
    case 'secondary':
    default:
      return SecondaryButton;
  }
};

const AddButton: React.FC<AddButtonProps> = (props) => {
  const { t } = useTranslation('button');
  const ButtonElement = getButtonElement(props.mode);
  return (
    <ButtonElement type="button" icon={<Icon name="add" />} data-testid="btnAdd" {...props}>
      {props.children || t('button:add')}
    </ButtonElement>
  );
};

export default AddButton;
